import { ref } from 'vue';
import MasifiConsoleAPI from 'dashboard/api/masifi/masifiConsole';
import store from 'dashboard/store';

// Masifi: ¿qué ve este usuario del Panel de Control? Un solo GET /console/me por CARGA de la app (estado de módulo:
// navegar no lo repite; consistencia M9, A-38), compartido por el menú y el guard de rutas. /me trae `pages`
// (Masifi::Console::Scope::PAGES: la ÚNICA regla de qué pantalla ve quién), `abilities`, `module_keys` y
// `module_defaults` (A-21); cada endpoint revalida alcance y página (la fuente de verdad es el backend). Un miembro de
// agencia tiene alcance solo en el dominio de su agencia (A-6): en el maestro su cuenta da 404 (A-7) y el acceso queda en null.
const access = ref(null);
const loaded = ref(false);
let inFlight = null;

export const resetControlPanelAccess = () => {
  access.value = null;
  loaded.value = false;
  inFlight = null;
};

// Pista para no pedir /me de más (el backend decide): un SuperAdmin o el administrador de alguna cuenta (el miembro de
// una agencia es administrador de su cuenta propia, R2.7). Un agente no genera ninguna petición.
export const canHaveAccess = user =>
  user?.type === 'SuperAdmin' ||
  Boolean(user?.accounts?.some(account => account.role === 'administrator'));

const load = user => {
  if (loaded.value) return Promise.resolve(access.value);
  if (!canHaveAccess(user)) {
    loaded.value = true;
    access.value = null;
    return Promise.resolve(null);
  }
  if (!inFlight) {
    inFlight = MasifiConsoleAPI.me()
      .then(({ data }) => {
        access.value = data?.scope ? data : null;
        loaded.value = true;
      })
      .catch(error => {
        access.value = null;
        // Un 4xx es la respuesta (sin Panel); un fallo de red o del servidor no se cachea: la próxima navegación (el
        // guard de ruta) vuelve a pedir /me en vez de dejar el menú oculto hasta recargar.
        const status = error?.response?.status;
        if (status && status < 500) loaded.value = true;
        else inFlight = null;
      })
      .then(() => access.value);
  }
  return inFlight;
};

export const useControlPanelAccess = () => ({ access, loaded, load });

// beforeEnter de una página del Panel: pasa solo si /me la trae en `pages`; si no, al inicio de la cuenta.
export const ensureControlPanelPage = key => async to => {
  const result = await load(store.getters.getCurrentUser);
  if (result?.pages?.includes(key)) return true;
  return { name: 'home', params: { accountId: to.params.accountId } };
};
